<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="main-card">
      <v-toolbar class="custom-toolbar ma-2" flat dense>
        <v-toolbar-title>Profile Photo</v-toolbar-title>
      </v-toolbar>

      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
          <v-row justify="center">
            <v-col v-if="photo_path" :cols="12" :sm="hasSignatureField && signature_path ? 6 : 12" class="text-center">
               <h3 class="mb-3">Student Photo</h3>
              <img :src="aws_path + photo_path" width="200" height="200" />
              <br>

              <v-btn class="mx-2" fab small color="primary darken-2" @click="downloadImg(aws_path + photo_path)">
                <v-icon>mdi-download</v-icon>
              </v-btn>

              <v-btn class="mx-2" fab small color="primary darken-2">
                <a target="_blank" :href="aws_path + photo_path">
                  <v-icon color="white">mdi-eye</v-icon>
                </a>
              </v-btn>
            </v-col>

            <v-col v-if="hasSignatureField && signature_path" :cols="12" :sm="photo_path ? 6 : 12" class="text-center">
               <h3 class="mb-3">Student Signature</h3>
              <img :src="aws_path + signature_path" width="200" height="200" />
              <br>

              <v-btn class="mx-2" fab small color="primary darken-2" @click="downloadImg(aws_path + signature_path)">
                <v-icon>mdi-download</v-icon>
              </v-btn>

              <v-btn class="mx-2" fab small color="primary darken-2">
                <a target="_blank" :href="aws_path + signature_path">
                  <v-icon color="white">mdi-eye</v-icon>
                </a>
              </v-btn>
            </v-col>

          </v-row>
         
          <br>
          <!-- <v-file-input id="newFile" ref="file" v-model="profile_image" accept="image/*" outlined dense rounded
            @change="handleFileChangeNew()"
            hint="Only jpg/jpeg allowed Its better to have photo with dimension of 200x200px"
            persistent-hint></v-file-input> -->

            <v-row justify="center">
              <!-- <v-col cols="12" sm="6" md="6" v-for="field in photo_fields" :key="field.field_name" v-if="field.isactive && showPhotoUpload"> -->
              <!-- Label -->
                <!-- <div class="pl-1 pb-2" style="font-size: 14px;">
                  <b>{{ field.label }}</b>
                  <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                </div> -->
                <!-- File -->
                <!-- <v-file-input v-if="field.input_type === 'file' && field.iseditable" v-model="profile_image"
                  prepend-icon="mdi-upload" outlined dense rounded :readonly="!field.iseditable" accept="image/*"
                  :filled="!field.iseditable" @change="handleFileChangeNew()"
                  persistent-hint /> -->
                <!-- hint="Only jpg/jpeg allowed Its better to have photo with dimension of 200x200px" -->
             <!-- </v-col> -->

            <v-col v-for="field in photo_fields" :key="field.field_name" v-if="field.isactive && showPhotoUpload"
              cols="12" sm="6" md="6" class="d-flex flex-column align-center px-4">
              <div class="pb-2 text-center">
                <b>{{ field.label }}</b>
              </div>

              <v-file-input v-if="field.input_type == 'file' && field.iseditable"
                v-model="uploadedFiles[field.field_name]" prepend-icon="mdi-upload" outlined dense rounded
                accept="image/*" @change="handleFileChangeNew(field)" style="width:100%; max-width:320px" />

              <v-btn color="primary" class="mt-2 ml-4" @click="uploadFile(field)">
                Upload {{ field.label.replace(/^Student\s+/i, '') }}
              </v-btn>

              <p v-if="fileDimensions[field.field_name]" class="mt-2 text-center">
                Height: {{ fileDimensions[field.field_name].height }} px<br>
                Width: {{ fileDimensions[field.field_name].width }} px
              </p>
            </v-col>
          </v-row>
         
        </v-col>

      </v-row>
      <template v-if="isAnyPhotoFieldActive && showPhotoUpload">
        <!-- <v-row dense justify="center">
          <p v-if="file">File Height: {{ fileHeight }}, File Width: {{ fileWidth }}</p>
        </v-row> -->

        <center>
          <b style="color:red">
            File Should Be In {{ allowed_extensions }} Format And Size Of Uploading
            Student Photo Should Be <= {{ imagesize }} MB
           </b>
           <br>
           <b style="color:red" v-if="hasSignatureField && signatureDimensionRequired">
             Signature Photo Should Be <= {{ signature_imagesize }} MB
           </b>
        </center>
        <center v-if="isdimentionrequired">
          <b style="color:red">
            Student Photo: Height <= {{ documentheight }}, Width <= {{ documentwidth }}
          </b>
        </center>
        <center v-if="hasSignatureField && signatureDimensionRequired">
          <b style="color:red">
            Student Signature: Height <= {{ signatureHeight }}, Width <= {{ signatureWidth }}
          </b>
        </center>

        <br>

        <!-- <v-row justify="center" class="pb-5">
          <v-btn text @click="uploadImage" :disabled="!isvaliddimantions " :loading="upload_image_loader"
            class="button-77">Upload Photo</v-btn>
        </v-row> -->
      </template>
      <br>
    </v-card>

    <v-dialog v-model="cropDialog" max-width="700px">
      <v-card>
        <v-card-title>Crop Image</v-card-title>
        <v-card-text>
          <div ref="imageContainer" style="position: relative; display: inline-block;">
            <img ref="cropImage" :src="cropImageSrc" style="max-width:100%; display:block;" />
            <div class="crop-box" :style="cropStyle" @mousedown.prevent="startMove">
              <div class="resize top" @mousedown.stop.prevent="startResize('top')"></div>
              <div class="resize bottom" @mousedown.stop.prevent="startResize('bottom')"></div>
              <div class="resize left" @mousedown.stop.prevent="startResize('left')"></div>
              <div class="resize right" @mousedown.stop.prevent="startResize('right')"></div>
              <div class="corner top-left" @mousedown.stop.prevent="startResize('top-left')"><span class="hor"></span><span class="ver"></span></div>
              <div class="corner top-right" @mousedown.stop.prevent="startResize('top-right')"><span class="hor"></span><span class="ver"></span></div>
              <div class="corner bottom-left" @mousedown.stop.prevent="startResize('bottom-left')"><span class="hor"></span><span class="ver"></span></div>
              <div class="corner bottom-right" @mousedown.stop.prevent="startResize('bottom-right')"><span class="hor"></span><span class="ver"></span></div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="applySquareCrop">Crop</v-btn>
          <v-btn text @click="cropDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  import { saveAs } from "file-saver";
  export default {
    props: {
      learner: {
        type: [String, Number], // Adjust type based on your actual value
        required: true,
      },
    },
    data() {
      return {
        photo_fields: [],
        color: "",
        snackbar: false,
        snackbar_msg: "",
        photo_path: null,
        signature_path: null,
        aws_path: null,
        file: null,
        fileHeight: null,
        learnerDivision_id: '',
        registration_number: "",
        fileWidth: null,
        imagesize: null,
        imagetype: null,
        signature_imagesize:null,
        profile_image: null,
        save_loader: false,
        allowed_extensions: ["jpg", "jpeg", "JPG", "JPEG", "png", "PNG"],
        req_imagetype_doc: null,
        req_imagetype_size: null, isvaliddimantions: true, isdimentionrequired: false, documentheight: null, documentwidth: null,
        upload_image_loader: false,
        cropDialog: false,
        cropImageSrc: null,
        cropTop: 0,
        cropLeft: 0,
        cropWidth: 200,
        cropHeight: 200,
        moving: false,
        resizing: null,
        hide_photo_upload:false,
        usertype:"",
        uploadedFiles: {},
        uploadLoader: {},
        currentField: null,
        fileDimensions: {},
        signatureHeight: null,
        signatureWidth: null,
        signatureDimensionRequired: false,
      };
    },
    watch: {
      learner(newVal, oldVal) {
        if (newVal) {
          this.getProfilePhoto();
        }
      },
    },
    computed: {
      isAnyPhotoFieldActive() {
        return this.photo_fields.some(f => f.isactive);
      },

      showPhotoUpload() {
        return !(this.usertype.toLowerCase() === "parent" && this.hide_photo_upload);
      },

      hasSignatureField() {
        return this.photo_fields.some(
          f => f.field_name === "student_signature_photo" && f.isactive
        );
      },

      cropStyle() {
        return {
          position: "absolute",
          top: this.cropTop + "px",
          left: this.cropLeft + "px",
          width: this.cropWidth + "px",
          height: this.cropHeight + "px",
          border: "2px dotted red",
          boxSizing: "border-box"
        };
      },
    },
    methods: {
      getProfilePhoto() {

        const data = {
          learner: this.learner
        }
        axios
          .post("/parent/getProfilePhoto", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.photo_path = res.data.photo_path;
              this.photo_fields = res.data.photo_fields;
              this.imagesize = res.data.imagesize;
              this.imagetype = res.data.imagetype;
              this.isdimentionrequired = res.data.isdimentionrequired;
              this.documentheight = res.data.height,
              this.documentwidth = res.data.width,
              this.learnerDivision_id = res.data.learnerDivision_id,
              this.registration_number = res.data.registration_number,
              this.hide_photo_upload = res.data.hide_photo_upload
              this.signature_path = res.data.signature_photo_path;
              this.signatureHeight = res.data.signature_height;
              this.signatureWidth = res.data.signature_width;
              this.signatureDimensionRequired = res.data.signature_dimension_required;
              this.signature_imagesize = res.data.signature_imagesize;
            } else {
              this.showSnackbar("error", res.data.snackbar);
            }

          })

      },
      // handleFileChangeNew() {
      //   if (this.isdimentionrequired == false) {
      //     return
      //   }
      //   const selectedFile = this.profile_image
      //   if (selectedFile) {
      //     this.file = selectedFile;
      //     const reader = new FileReader();
      //     reader.onload = (e) => {
      //       const img = new Image();
      //       img.onload = () => {
      //         this.fileHeight = img.height;
      //         this.fileWidth = img.width;
      //         // alert(this.fileHeight)
      //         // alert(this.documentheight)
      //         // alert(this.fileWidth)
      //         // alert(this.documentwidth)
      //         if (this.fileHeight > this.documentheight || this.fileWidth > this.documentwidth) {
      //           alert("Height And Width Not Matching..")
      //           this.isvaliddimantions = false
      //         } else {
      //           this.isvaliddimantions = true
      //         }
      //       };
      //       img.src = e.target.result;
      //     };
      //     reader.readAsDataURL(selectedFile);

      //   }


      // },
     
      handleFileChangeNew(field) {
        this.currentField = field.field_name;
        const selectedFile = this.uploadedFiles[field.field_name];
        if (!selectedFile) return;

        if (selectedFile) {
          this.file = selectedFile;
          
          let ext = selectedFile.name.split(".").pop().toLowerCase();
          if (!this.allowed_extensions.map(e => e.toLowerCase()).includes(ext)) {
            this.showSnackbar("error", "Invalid file format!");
            this.profile_image = null;
            this.file = null;
            return;
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            this.cropImageSrc = e.target.result;
            this.cropDialog = true;
          };
          reader.readAsDataURL(selectedFile);
        }
      },

      applySquareCrop() {
        const img = this.$refs.cropImage;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const scaleX = img.naturalWidth / img.width;
        const scaleY = img.naturalHeight / img.height;

        let cropX = this.cropLeft * scaleX;
        let cropY = this.cropTop * scaleY;
        let cropW = this.cropWidth * scaleX;
        let cropH = this.cropHeight * scaleY;
        
        cropX = Math.max(0, cropX);
        cropY = Math.max(0, cropY);

        if (cropX + cropW > img.naturalWidth) cropW = img.naturalWidth - cropX;
        if (cropY + cropH > img.naturalHeight) cropH = img.naturalHeight - cropY;

        canvas.width = cropW;
        canvas.height = cropH;
        ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);

        canvas.toBlob((blob) => {
          const croppedFile = new File([blob], this.file.name, { type: this.file.type });
          // this.profile_image = croppedFile;
          this.$set(this.uploadedFiles, this.currentField, croppedFile);
          this.file = croppedFile;

          const imgCheck = new Image();
          imgCheck.onload = () => {
            const height = imgCheck.height;
            const width = imgCheck.width;

            this.$set(this.fileDimensions, this.currentField, {
                height,
                width
            });

          let maxHeight = this.documentheight;
          let maxWidth = this.documentwidth;
          let dimensionRequired = this.isdimentionrequired;

          if (this.currentField === "student_signature_photo") {
              maxHeight = this.signatureHeight;
              maxWidth = this.signatureWidth;
              dimensionRequired = this.signatureDimensionRequired;
          }

          if (dimensionRequired && (height > maxHeight || width > maxWidth)) {
              alert( `Height should be <= ${maxHeight}px and Width should be <= ${maxWidth}px`);
              this.isvaliddimantions = false;
          } else {
              this.isvaliddimantions = true;
          }
          };
          imgCheck.src = URL.createObjectURL(croppedFile);

          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(croppedFile);
          const fileInput = document.querySelector('.v-file-input input[type="file"]');
          if (fileInput) fileInput.files = dataTransfer.files;
        }, this.file.type || 'image/jpeg');

        this.cropDialog = false;
      },
      startMove() {
        this.moving = true;
        document.addEventListener("mousemove", this.moveSquare);
        document.addEventListener("mouseup", this.stopMove);
      },
      moveSquare(e) {
        if (!this.moving) return;
        const container = this.$refs.imageContainer.getBoundingClientRect();
        const img = this.$refs.cropImage;
        let x = e.clientX - container.left - this.cropWidth / 2;
        let y = e.clientY - container.top - this.cropHeight / 2;
        x = Math.max(0, Math.min(x, img.width - this.cropWidth));
        y = Math.max(0, Math.min(y, img.height - this.cropHeight));
        this.cropLeft = x;
        this.cropTop = y;
      },
      stopMove() {
        this.moving = false;
        document.removeEventListener("mousemove", this.moveSquare);
        document.removeEventListener("mouseup", this.stopMove);
      },
      startResize(direction) {
        this.resizing = direction;
        document.addEventListener("mousemove", this.resizeCrop);
        document.addEventListener("mouseup", this.stopResize);
      },
      stopResize() {
        this.resizing = null;
        document.removeEventListener("mousemove", this.resizeCrop);
        document.removeEventListener("mouseup", this.stopResize);
      },
      resizeCrop(e) {
        if (!this.resizing) return;
        const img = this.$refs.cropImage;
        const rect = img.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        switch (this.resizing) {
          case "top":
            let diffTop = this.cropTop - mouseY;
            this.cropTop = mouseY;
            this.cropHeight += diffTop;
            break;
          case "bottom":
            this.cropHeight = mouseY - this.cropTop;
            break;
          case "left":
            let diffLeft = this.cropLeft - mouseX;
            this.cropLeft = mouseX;
            this.cropWidth += diffLeft;
            break;
          case "right":
            this.cropWidth = mouseX - this.cropLeft;
            break;
          case "top-left":
            let diffTLX = this.cropLeft - mouseX; let diffTLY = this.cropTop - mouseY;
            this.cropLeft = mouseX; this.cropTop = mouseY;
            this.cropWidth += diffTLX; this.cropHeight += diffTLY;
            break;
          case "top-right":
            let diffTRX = mouseX - (this.cropLeft + this.cropWidth); let diffTRY = this.cropTop - mouseY;
            this.cropTop = mouseY; this.cropWidth += diffTRX; this.cropHeight += diffTRY;
            break;
          case "bottom-left":
            let diffBLX = this.cropLeft - mouseX; let diffBLY = mouseY - (this.cropTop + this.cropHeight);
            this.cropLeft = mouseX; this.cropWidth += diffBLX; this.cropHeight += diffBLY;
            break;
          case "bottom-right":
            this.cropWidth = mouseX - this.cropLeft; this.cropHeight = mouseY - this.cropTop;
            break;
        }

        if (this.cropWidth < 50) this.cropWidth = 50;
        if (this.cropHeight < 50) this.cropHeight = 50;
        if (this.cropLeft < 0) { this.cropWidth += this.cropLeft; this.cropLeft = 0; }
        if (this.cropTop < 0) { this.cropHeight += this.cropTop; this.cropTop = 0; }
        if (this.cropLeft + this.cropWidth > img.width) this.cropWidth = img.width - this.cropLeft;
        if (this.cropTop + this.cropHeight > img.height) this.cropHeight = img.height - this.cropTop;
      },
      
      downloadImg(url) {
        // let url = this.remoteURL();
        let prn = this.registration_number;
        if (prn == null) {
          prn = "stud";
        }
        prn += ".jpg";
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            saveAs(blob, prn);
          })
          .catch((err) => {
            alert(err);
          });
        console.log("downloading", url);
      },
      // uploadImage() {
      //   for (const field of this.photo_fields) {
      //     if (field && field.isactive && field.required) {
      //       let val;
      //       // Map field_name to the correct v-model variable
      //       if (field.field_name === 'student_photo') {
      //         val = this.profile_image;
      //       }

      //       if (field.input_type === 'file') {
      //         if (!val) {
      //           this.showSnackbar('error', `${field.label} is required`);
      //           return false;
      //         }
      //       } else {
      //         const trimmedVal = val !== null && val !== undefined ? String(val).trim() : '';
      //         if (trimmedVal === '') {
      //           this.showSnackbar('error', `${field.label} is required`);
      //           return false;
      //         }
      //       }
      //     }
      //   }
      //   let formData = new FormData();
      //   formData.append("files", this.profile_image);
      //   formData.append("ldid", this.learnerDivision_id);
      //   formData.append("registration_number", this.registration_number);
      //   formData.append("fileHeight", this.fileHeight);
      //   formData.append("fileWidth", this.fileWidth);

      //   this.upload_image_loader = true;
      //   axios
      //     .post("/parent/saveChildPhoto", formData, {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     })
      //     .then((res) => {
      //       if (res.data.flag == "YES") {
      //         this.showSnackbar("success", res.data.snackbar);
      //         this.photo_path = res.data.photo_path;
      //       } else if (res.data.status == "NO") {
      //         this.showSnackbar("#b71c1c", res.data.fmsg);
      //         this.profile_image = null;
      //       }
      //       else {
      //         this.showSnackbar("error", res.data.snackbar);
      //       }
      //       this.upload_image_loader = false;
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong!!!");
      //       this.upload_image_loader = false;
      //     })
      //     .finally(() => {
      //       this.upload_image_loader = false;
      //     });
      // },
      uploadImage() {
        const file = this.uploadedFiles.student_photo;

        if (!file) {
          this.showSnackbar("error", "Student Photo is required");
          return;
        }

        let formData = new FormData();
        formData.append("files", file);
        formData.append("ldid", this.learnerDivision_id);
        formData.append("registration_number", this.registration_number);

        const dimension = this.fileDimensions.student_photo || {};
        formData.append("fileHeight", dimension.height || "");
        formData.append("fileWidth", dimension.width || "");

        this.upload_image_loader = true;

        axios.post("/parent/saveChildPhoto", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          if (res.data.flag === "YES") {
            this.showSnackbar("success", res.data.snackbar);
            this.photo_path = res.data.photo_path;
            this.uploadedFiles.student_photo = null;
            this.$delete(this.fileDimensions, "student_photo");
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch(() => {
          this.showSnackbar("error", "Something went wrong!");
        })
        .finally(() => {
          this.upload_image_loader = false;
        });
      },

      uploadSignature() {
        const file = this.uploadedFiles.student_signature_photo;

        if (!file) {
          this.showSnackbar("error", "Student Signature is required");
          return;
        }

        let formData = new FormData();
        formData.append("files", file);
        formData.append("ldid", this.learnerDivision_id);
        formData.append("registration_number", this.registration_number);

        const dimension = this.fileDimensions.student_signature_photo || {};
        formData.append("fileHeight", dimension.height || "");
        formData.append("fileWidth", dimension.width || "");

        this.upload_image_loader = true;

        axios.post("/parent/saveChildSignature", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          if (res.data.flag === "YES") {
            this.showSnackbar("success", res.data.snackbar);
            this.signature_path = res.data.signature_photo_path;
            this.uploadedFiles.student_signature_photo = null;
            this.$delete(this.fileDimensions, "student_signature_photo");
          } else {
            this.showSnackbar("error", res.data.fmsg);
          }
        })
        .catch(() => {
          this.showSnackbar("error", "Something went wrong!");
        })
        .finally(() => {
          this.upload_image_loader = false;
        });
      },

      uploadFile(field) {
        if (field.field_name === "student_photo") {
          this.uploadImage();
        } else if (field.field_name === "student_signature_photo") {
          this.uploadSignature();
        } else {
          console.warn("Unknown field:", field.field_name);
        }
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
    mounted() {
      this.aws_path = localStorage.getItem("awspath");
      this.usertype = localStorage.getItem("EPS-ut")
      this.getProfilePhoto();
    },
  };
</script>

<style scoped>
  .button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
  }

  /* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
  }

  .button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.2)),
      linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: 0.24;
  }

  .main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }

  .crop-box {
    position: absolute;
    border: 2px dotted red;
    box-sizing: border-box;
  }
  .resize {
    position: absolute;
    background: transparent;
  }
  .resize.top { 
    top: -5px; 
    left: 0;
     width: 100%; 
     height: 10px; 
     cursor: ns-resize; 
  }
  .resize.bottom { 
    bottom: -5px; 
    left: 0; 
    width: 100%; 
    height: 10px; 
    cursor: ns-resize; 
  }
  .resize.left { 
    left: -5px; 
    top: 0; 
    width: 10px; 
    height: 100%; 
    cursor: ew-resize;
  }
  .resize.right { 
    right: -5px; 
    top: 0; 
    width: 10px;
    height: 100%; 
    cursor: ew-resize; 
  }

  .crop-box .corner { 
    position: absolute; 
    width: 20px; 
    height: 20px; 
    z-index: 10; 
  }
  .crop-box .corner span { 
    position: absolute; 
    background-color: red; 
  }
  .crop-box .corner .hor { 
    height: 3px; 
    width: 14px; 
  }
  .crop-box .corner .ver {
    width: 3px; 
    height: 14px; 
  }

  .crop-box .corner.top-left .hor, .crop-box .corner.top-left .ver { 
    top: 0; 
    left: 0; 
  }
  .crop-box .corner.top-right .hor, .crop-box .corner.top-right .ver { 
    top: 0; 
    right: 0; 
  }
  .crop-box .corner.bottom-left .hor, .crop-box .corner.bottom-left .ver { 
    bottom: 0; 
    left: 0; 
  }
  .crop-box .corner.bottom-right .hor, .crop-box .corner.bottom-right .ver { 
    bottom: 0; 
    right: 0; 
  }

  .crop-box .corner.top-left { 
    top: -4px; 
    left: -4px; 
    cursor: nwse-resize; 
  }
  .crop-box .corner.top-right { 
    top: -4px; 
    right: -4px; 
    cursor: nesw-resize; 
  }
  .crop-box .corner.bottom-left { 
    bottom: -4px; 
    left: -4px; 
    cursor: nesw-resize; 
  }
  .crop-box .corner.bottom-right { 
    bottom: -4px; 
    right: -4px; 
    cursor: nwse-resize; 
  }
</style>